export default "__VITE_ASSET__B$XPo1bP__"